export default {
  description: 'Hier siehst Du ein paar Bildschirmfotos von unserem Spiel.',
  title: 'Throbax TD Bildschirmfotos',
  gallery: 'Ein paar Schnappschüsse aus einer früheren Version',
  gallery1: 'Splash Screen',
  description1: 'This is our splash screen since we got rid of the splash video.',
  gallery2: 'Hauptmenü',
  gallery3: 'Einstellungen',
  gallery4: 'Graphik-Einstellungen',
  gallery5: 'Soundeinstellungen',
  gallery6: 'Spieleinstellungen',
  gallery7: 'Levelauswahl',
  gallery8: 'Intro - Ausschnitt',
  gallery9: 'Intro - Ausschnitt',
  gallery10: 'Ughlar der mächtige',
  gallery11: 'Erstes Level',
  gallery12: 'Der Kampf beginnt',
  gallery13: 'Verschiedene Levels',
  gallery14: 'Fürchte die Dunkelheit',
  gallery15: 'Helden - Kommando-Warteschlange',
  gallery16: 'Ein Gefecht',
  gallery17: 'Verschiedene Feinde',
  gallery18: 'Verschiedene Türme',
  gallery19: 'Stromversorgung',
  gallery20: 'Action-Reich',
  gallery21: 'Zoom',
  gallery22: 'Blitz Effekte',
  gallery23: 'Gift Türme'
}
